import { clearTokens, getAccessToken } from '../utility/tokenStorage';
import { parseJwt } from './tokenUtils';
import { refreshTokens } from './tokenService';

let refreshTimer: number | null = null;

export function clearTokenRefreshSchedule() {
    if (refreshTimer !== null) {
        window.clearTimeout(refreshTimer);
        refreshTimer = null;
    }
}

export function scheduleTokenRefresh() {
    clearTokenRefreshSchedule();

    const access = getAccessToken();
    const payload = parseJwt(access);
    if (!payload?.exp) {
        return;
    }

    const expiresAtMs = payload.exp * 1000;
    const now = Date.now();
    const runInMs = Math.max(expiresAtMs - now - 2 * 60 * 1000, 5000);

    refreshTimer = window.setTimeout(async () => {
        try {
            await refreshTokens();
            scheduleTokenRefresh();
        } catch {
            clearTokens();
            window.location.href = '/';
        }
    }, runInMs);
}
